module.exports = __webpack_public_path__ + "img/tourist-information_even.6133ed4d.svg";